<template>
  <div class="top-nav">
    <div class="container header-nav">
      <a href="https://www.bjshfb.com" class="navbar-brand logoImg"></a>
      <ul class="nav navbar-nav navbar-fixed-top right-nav">
        <li class="nav-item">
          <slot>
            <router-link v-if="isShowRegister" to="/register">注册</router-link>
          </slot>
          <span v-if="isShowRegister">|</span>
          <a href="https://www.bjshfb.com">返回官网</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { canRegister } from "@/api/login";
export default {
  name: "TopNav",
  props: {
    msg: String
  },
  computed: {
    isShowRegister() {
      return canRegister();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-nav {
  background: #0c9af4;
  color: #ffffff;
  width: 100%;
  height: 50px;
}
.header-nav {
  text-align: left;
}
.right-nav {
  float: right;
}

.navbar {
  border: none;
  margin: 0;
  padding: 0;
}

.logoImg {
  display: inline-block;
  background: url("../assets/logo.png") no-repeat;
  background-size: 100% 100%;
  width: 135px;
  height: 20px;
  margin-top: 16px;
}

.nav-item > a,
.nav-item > span {
  line-height: 50px;
  padding: 0 3px;
  user-select: none;
  text-decoration: none;
}
ul li {
  list-style: none;
}
a,
a:visited {
  cursor: pointer;
  color: white;
}

@media only screen and (min-width: 992px) {
  .header-nav {
    width: 970px;
  }
  .logoImg {
    width: 221px;
    height: 29px;
    margin-top: 10px;
  }
}
</style>
